import { ProductStatus } from '../enums/product-statuses';
import { ProductConfig } from '../interfaces/product-config.interface';

export const ProductStatusConfig = new Map<ProductStatus, ProductConfig>([
  [
    ProductStatus.PRE_RELEASE,
    {
      status: 'preRelease',
      statusColor: '#00AEEF',
      iconClass: 'alc-horn-trumpet-icon',
    },
  ],
  [
    ProductStatus.ACTIVE,
    {
      status: 'active',
      statusColor: '#00AE44',
    },
  ],
  [
    ProductStatus.RUN_DOWN,
    {
      status: 'runDown',
      statusColor: '#FF6B12',
      iconClass: 'alc-download-arrow-circle-icon',
    },
  ],
  [
    ProductStatus.USE_UP,
    {
      status: 'useUp',
      statusColor: '#FF6B12',
      iconClass: 'alc-download-arrow-circle-icon',
    },
  ],
  [
    ProductStatus.RETURNS_REBATE,
    {
      status: 'returnsRebate',
      statusColor: '#9B1A2F',
      iconClass: 'alc-warning-error-icon',
    },
  ],
  [
    ProductStatus.INACTIVE,
    {
      status: 'inactive',
      statusColor: '#9B1A2F',
      iconClass: 'alc-warning-error-icon',
    },
  ],
  [
    ProductStatus.UNAVAILABLE,
    {
      status: 'unavailable',
      statusColor: '#9B1A2F',
      iconClass: 'alc-warning-error-icon',
    },
  ],
]);

export const errorPartStatusCodesForContract = new Set([
  ProductStatus.INACTIVE,
  ProductStatus.RETURNS_REBATE,
  ProductStatus.PRE_RELEASE,
]);

export const productAvailableCodes = new Set([ProductStatus.ACTIVE, ProductStatus.RUN_DOWN, ProductStatus.PRE_RELEASE]);

export const TRUE_PRODUCT_ATTRIBUTE_VALUES = ['Yes', 'true', true];
export const FALSE_PRODUCT_ATTRIBUTE_VALUES = ['no', 'false', false];

export const ADD_AFTER_LOCATION_ID = 'Add After';
